import { Form, Input } from "antd";
import LoadableButton from "../../../../components/buttons/LoadableButton";



const BankDetails = ({ onFinish, isLoading, form }) => {


  return (
    <div className="md:p-6 p-4 border-2 border-light rounded-[10px] h-full">
      <Form form={form} layout="vertical" autoComplete="off" onFinish={onFinish} requiredMark={false}>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
          <Form.Item
            label={<span className="text-sm text-[#2F2B3DCC] font-medium">Full Name</span>}
            name="fullName" rules={[{ required: true, message: "Please enter full name." }]}>
            <Input placeholder="Enter full name" className="py-2" />
          </Form.Item>
          <Form.Item
            label={<span className="text-sm text-[#2F2B3DCC] font-medium">Bank Name</span>}
            name="bankName" rules={[{ required: true, message: "Please enter bank name." }]}>
            <Input placeholder="Enter bank name" className="py-2" />
          </Form.Item>
          <Form.Item
            label={<span className="text-sm text-[#2F2B3DCC] font-medium">Account Number</span>}
            name="bankAccountNumber" rules={[{ required: true, message: "Please enter account number." }]}>
            <Input placeholder="Enter account number" className="py-2" />
          </Form.Item>
          <Form.Item
            label={<span className="text-sm text-[#2F2B3DCC] font-medium">Branch Address</span>}
            name="bankBranchAddress" rules={[{ required: true, message: "Please enter branch address." }]}>
            <Input placeholder="Enter branch address" className="py-2" />
          </Form.Item>
          <Form.Item
            label={<span className="text-sm text-[#2F2B3DCC] font-medium">IFSC Code</span>}
            name="ifscCode" rules={[{ required: true, message: "Please enter IFSC code." }]}>
            <Input placeholder="Enter IFSC code" className="py-2" />
          </Form.Item>
          <Form.Item
            label={<span className="text-sm text-[#2F2B3DCC] font-medium">SWIFT / BIC Code</span>}
            name="swifT_BIC_Code" rules={[{ required: true, message: "Please enter SWIFT / BIC code." }]}>
            <Input placeholder="Enter SWIFT / BIC code" className="py-2" />
          </Form.Item>
          <Form.Item
            label={<span className="text-sm text-[#2F2B3DCC] font-medium">IBAN</span>}
            name="iban" rules={[{ required: true, message: "Please enter IBAN." }]}>
            <Input placeholder="Enter IBAN" className="py-2" />
          </Form.Item>
        </div>
        <div className="mt-6 flex gap-4">
          <LoadableButton
            type="submit"
            className="bg-primary text-sm text-white font-medium px-6 py-2 rounded-lg themeHover duration-500"
            lable="Save Bank Details"
            loadingLable="Saving..."
            isLoading={isLoading}
            disabled={isLoading}
          />
        </div>
      </Form>
    </div>
  );
};

export default BankDetails;
